import { parseJSON } from './json';
import { API_ENDPOINT } from '../constants';

/**
* Small client search used by the "Client" filter on the external API
* analytics page (VD-725). Reuses the existing clients list endpoint, there is
* no dedicated autocomplete route.
*/
export const searchClients = (text, limit = 8) => {
    return fetch(`${API_ENDPOINT}/data/clients`, {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
        },
        body: JSON.stringify({
            page: 0,
            entries: limit,
            filter: text,
            sortType: 1,
            sortField: 'username',
            type: 'all',
        }),
    }).then(parseJSON).then(({ result, status }) => {
        if (status >= 200 && status < 300 && result && Array.isArray(result.items)) {
            return result.items.map((item) => ({
                _id: item._id,
                username: item.username,
                email: item.email,
                customerNumber: item.customerData ? item.customerData.id : null,
            }));
        }

        return [];
    });
};
